module.exports = __webpack_public_path__ + "static/Web-9e8c001eff27618959caa38d5dfbf0e0.jpg";